import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLaunch$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLaunch extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '381b92a99dfea855fe3088f2fbdcc88f2483b117', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e1f7397ff07717550c68569948bce9ad451e3ade', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '98b095af60858c030533ac9bfeeebae439112037', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.843 4.135A.5.5 0 0 1 18 4.5v.85a11 11 0 0 1-3.1 7.72 12.7 12.7 0 0 1-2.06 1.67l-.59 2.52a.4.4 0 0 1-.67.19l-7.07-7.07a.4.4 0 0 1 .19-.67l2.54-.59a12 12 0 0 1 1.66-2c2.04-2 4.783-3.12 7.64-3.12h.93a.5.5 0 0 1 .373.135M4.147 15.454a.5.5 0 0 1 0-.708l.707-.707a.5.5 0 0 1 .707 0l.354.354a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0zm2.013 2a.5.5 0 0 1 0-.708l.707-.707a.5.5 0 0 1 .707 0l.353.354a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0zm7.72-5.404a10.3 10.3 0 0 1-3.28 2.25l-2.9-2.86A10.6 10.6 0 0 1 10 8.18a9.43 9.43 0 0 1 6.5-2.68 9.46 9.46 0 0 1-2.66 6.55zM12 9a1 1 0 0 1 .71.29A1 1 0 0 1 13 10a1 1 0 1 1-1-1", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-launch", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-launch"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-launch":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLaunch$1);
            }
            break;
    } });
}

const CosmosIconLaunch = CosmosIconLaunch$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLaunch, defineCustomElement };
